import api from "../../services/api.mapSetup.service";
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { Map, MapSetupState, MapSetupLayer, MapSetupLayerItemRequest, MapSetupItem } from "./types";

export const actions: ActionTree<MapSetupState, RootState> = {
    async addUpdateMapLayer({ commit }, mapLayer: FormData) {
        let result = await api.addUpdateMapLayer(mapLayer);
        let layer = new MapSetupLayer(result.data)
        commit("addUpdateMapSetupLayer", layer);
        commit("setSelectedLayerId", layer.mapLayerId);
    },

    async deleteMapLayer({ commit }, mapSetupLayer: MapSetupLayer) {
        await api.deleteMapLayer(mapSetupLayer.mapLayerId);
        commit("deleteMapSetupLayer", mapSetupLayer);
    },
    async updateAreaLatLong({ commit }, { groupId, latLong }) {
        await api.updateAreaLatLong(groupId, latLong);
        commit("updateAreaLatLong", { groupId, latLong });
    },
    async updateMapItem({ commit }, mapSetupItemRequest: MapSetupLayerItemRequest): Promise<MapSetupItem> {

        let result = await api.updateMapLayerItem(mapSetupItemRequest.mapSetupLayerItem);

        mapSetupItemRequest.mapSetupLayerItem = result.data;
        commit("addUpdateMapSetupLayerItem", mapSetupItemRequest);
        return mapSetupItemRequest.mapSetupLayerItem;
    },
    async deleteMapItem({ commit }, mapSetupItemRequest: MapSetupLayerItemRequest) {
        await api.deleteMapLayerItem(mapSetupItemRequest.mapSetupLayerItem.mapLayerItemID);
        commit("removeMapSetupItem", mapSetupItemRequest);
    },
    async deleteMap({ commit, state }, mapId: number) {
        try {
            await api.deleteUnconvertedMap(mapId);

            commit("deleteMap", mapId);

            commit("setNotificationOptions", {
                type: "success",
                title: "Map Deleted",
                text: "Map was deleted."
            });
        } catch {
            commit("setNotificationOptions", {
                type: "error",
                title: "Map Not Deleted",
                text: "Map could not be deleted."
            });
        }
    },
    async loadUnconvertedMaps({ commit }, groupId: number): Promise<void> {
        const { data } = await api.loadUnconvertedMaps(groupId);
        commit("setUnconvertedMaps", data ?? []);
    },
};
